<template>
  <div class="flex flex-col bg-white shadow-2l rounded-lg p-6 relative">
    <div class="flex pb-4">
      <div class="pr-4">
        <img
          :src="`${$settings.image_url}/store/${id}/logo.jpg`"
          alt=""
          class="object-cover w-16 rounded-full"
        />
      </div>
      <div class="r">
        <h3 class="text-xl font-bold">{{ store_title }}</h3>
        <small class="text-gray-600"
          >Compartilhe o link abaixo em qualquer mídia social</small
        >
      </div>
    </div>
    <div class="flex flex-col md:flex-row">
      <input
        type="text"
        v-model="alias"
        readonly
        class="border rounded-none md:rounded-md md:rounded-r-none p-2 text-indigo-600 font-bold flex-grow text-sm focus:outline-none"
      />
      <button
        @click="doCopy()"
        class="border border-l-0 text-indigo-600 focus:bg-indigo-600 focus:text-white bg-indigo-100 font-bold px-4 py-2 rounded-b md:rounded-md md:rounded-l-none text-sm focus:outline-none"
      >
        Copiar Link
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoreCard',
  props: {
    store_title: {
      type: String,
      default: 'Loading...'
    },
    id: {
      type: String,
      default: null
    },
    slug: {
      type: String,
      default: 'loading'
    }
  },
  computed: {
    alias() {
      return `${this.slug}.${this.$settings.store_url}`
    }
  },
  methods: {
    doCopy() {
      this.$copyText(this.alias).then(
        (e) => {
          this.$toasted.success('Link copiado!', {
            position: 'bottom-center',
            duration: 5000,
            icon: 'check'
          })
        },
        function (e) {
          this.$toasted.error('Erro copiado!', {
            position: 'bottom-center',
            duration: 5000,
            icon: 'check'
          })
        }
      )
    }
  },
  mounted() {}
}
</script>

<style>
</style>
